import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Enfant } from '../devis-formulaire/Models/Enfant';
import { NiveauRemboursement } from '../devis-formulaire/Models/NiveauRemboursement';
import { Personne } from '../devis-formulaire/Models/Personne';

@Injectable({
  providedIn: 'root',
})
export class MyDataService {
  constructor() {}

  //Sharing data between Unrelated component:
  //Component 1 health-assuré-form
  //Component 2 formula-picker-b2c
  //For Transfert data Personne Model//
  private dataSource = new BehaviorSubject<Personne>(
    new Personne(
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      new Enfant(0, []),
      '',
      new NiveauRemboursement('', '', '', '', ''),
      '',
      '',
      '',
      false,
    ),
  );
  currentData: any = this.dataSource.asObservable();

  changeData(data: any) {
    this.dataSource.next(data);
  }

  //For ControllistParam
  _value2!: any;
  private dataSource_healthModelStoredData = new BehaviorSubject<any>(
    this._value2,
  );
  currentData_healthModelStoredData: any =
    this.dataSource_healthModelStoredData.asObservable();

  changeData_in_healthModelStoredData(data: any) {
    this.dataSource_healthModelStoredData.next(data);
  }
}
